"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Subject_1 = require("rxjs/Subject");
var AbstractDestructionSubject = /** @class */ (function () {
    function AbstractDestructionSubject() {
        this.destroySubject$ = new Subject_1.Subject();
    }
    AbstractDestructionSubject.prototype.ngOnDestroy = function () {
        this.destroySubject$.next();
        this.destroySubject$.complete();
    };
    return AbstractDestructionSubject;
}());
exports.AbstractDestructionSubject = AbstractDestructionSubject;
//# sourceMappingURL=abstract-destruction-subject.js.map